import * as React from 'react';
import { Link } from "gatsby"
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

// export default function SearchAppBar() {
//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar>
//           {/* <IconButton
//             size="large"
//             edge="start"
//             color="inherit"
//             aria-label="open drawer"
//             sx={{ mr: 2 }}
//           >
//             <MenuIcon />
//           </IconButton> */}
          
//           <Typography
//             className='appBarTitle'
//             variant="h6"
//             noWrap
//             component="div"
//             sx={{ flexGrow: 1, display: { xs: 'block' }, 
//             fontSize: '1.7rem', fontFamily: 'Poiret One',
//             textDecoration: 'none' }}
//           >
//             <Link to="/">J + A</Link>
//           </Typography>
          
//           {/* <Search>
//             <SearchIconWrapper>
//               <SearchIcon />
//             </SearchIconWrapper>
//             <StyledInputBase
//               placeholder="Search…"
//               inputProps={{ 'aria-label': 'search' }}
//             />
//           </Search> */}
//           <a href="https://www.youtube.com/c/jaylaandartur" target='_blank' style={{color: 'inherit'}}>
//           <IconButton
//                 edge="start"
//                 className="toolbar-menu-icon"
//                 color="inherit"
//                 aria-label="open drawer"
//                 style={{textDecoration: 'none'}}
//             >
//               <YouTubeIcon fontSize='large' />
//             </IconButton>
//             </a>

//         </Toolbar>
//       </AppBar>
//     </Box>
//   );
// }

export default function SearchAppBar() {
  return (
    <Box className='top-bar'>
      <Box className='top-bar-title-box'>
        <Link to="/" className='top-bar-title'>J + A</Link>
      </Box>
      <Box className='top-bar-pages-container'>
        <Box className='top-bar-pages'>
          <Link to="/" className='top-bar-page'>Home</Link>
          <Link to="/rugs" className='top-bar-page'>Rugs</Link>
          <Link to="/rv" className='top-bar-page'>RV</Link>
          <Link to="/recipes" className='top-bar-page'>Recipes</Link>
          <Link to="/travel" className='top-bar-page'>Travel</Link>
        </Box>
        {/* <Box className='top-bar-tags'>
        <Link to="/" className='top-bar-tag'>#streamingsaturdays</Link>
        </Box> */}
      </Box>
      <div style={{display: "flex"}} className='top-bar-icons'>
      
            <a href="https://www.youtube.com/c/jaylaandartur" target='_blank' rel="noreferrer" className='top-bar-icon' >
          <IconButton
                edge="start"
                className="toolbar-menu-icon"
                color="inherit"
                aria-label="open drawer"
                style={{textDecoration: 'none'}}
            >
              <YouTubeIcon fontSize='large' />
            </IconButton>
            </a>
            <a href="https://www.instagram.com/jaylaandartur/" target='_blank' rel="noreferrer" className='top-bar-icon' >
          <IconButton
                edge="start"
                className="toolbar-menu-icon"
                color="inherit"
                aria-label="open drawer"
                style={{textDecoration: 'none'}}
            >
              <InstagramIcon fontSize='large' />
            </IconButton>
            </a>
            </div>
    </Box>
  );
}
